module.exports = __webpack_public_path__ + "img/techHub.daec940b.png";